<template>
  <div>
    <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
      {{ $t(`mygwf.components.Label.meter`) }}
    </h4>
    <!-- Meter Search -->
    <base-fieldset>
      <base-input
        v-model.trim="meterSerial"
        size="sm"
        clearable
        :placeholder="$t(`mygwf.components.Label.serial`)"
      />

      <!-- Meter Select -->

      <base-select
        :options="meterTypes"
        mode="multiple"
        v-model="meterType"
        :option-type="{id: 'value', label: 'label'}"
        allowClear
        open-direction="bottom"
        :placeholder="$t(`mygwf.components.Label.device_type`)"
        size="sm"
      />
    </base-fieldset>
    <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
      {{ $t(`mygwf.components.Label.com_module`) }}
    </h4>
    <!-- Communication Module Search -->
    <base-fieldset>
      <base-input
        v-model.trim="keySerial"
        size="sm"
        clearable
        :placeholder="$t(`mygwf.components.Label.serial`)"
      />
      <!-- Communication Module Select -->
      <base-select
        :options="comdTypes"
        mode="multiple"
        v-model="comdType"
        :option-type="{id: 'value', label: 'label'}"
        allowClear
        open-direction="bottom"
        :placeholder="$t(`mygwf.components.Label.device_type`)"
        size="sm"
      />
    </base-fieldset>
    <!-- Measuring Point Search -->
    <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
      {{ $t(`mygwf.components.Label.measuring_point`) }}
    </h4>
    <base-fieldset>
      <base-input
        v-model.trim="measuringPoint"
        size="sm"
        clearable
        :placeholder="$t(`mygwf.components.Label.name`)"
      >
      </base-input>
    </base-fieldset>
    <base-fieldset>
      <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
        {{ $t(`mygwf.components.Label.alerts`) }}
      </h4>
      <base-select
        :options="alerts"
        mode="multiple"
        v-model="alert"
        :option-type="{id: 'value', label: 'label'}"
        allowClear
        open-direction="bottom"
        size="sm"
      />
    </base-fieldset>
    <!-- Company Select -->
    <base-fieldset>
      <CompanySelect :filterArray="keyCompany" size="xs" class="mt-1" />
    </base-fieldset>

    <base-fieldset>
      <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
        {{ $t(`mygwf.components.Label.groups`) }}
      </h4>
      <base-select
        :options="groupList"
        mode="multiple"
        v-model="groups"
        :option-type="{id: 'uuid', label: 'name'}"
        allowClear
        open-direction="bottom"
        :placeholder="$t(`mygwf.components.Label.name`)"
        size="sm"
      />
    </base-fieldset>
  </div>
</template>

<script>
import {
  BaseSelect,
  BaseInput,
  BaseIcon,
  BaseButton,
  BaseButtonIcon,
  BaseFieldset,
} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import 'ant-design-vue/lib/popover/style/index.css'
import _isEmpty from 'lodash-es/isEmpty'
import result from 'autoprefixer/data/prefixes'

export default {
  components: {
    BaseSelect,
    BaseInput,
    BaseIcon,
    BaseFieldset,
    BaseButtonIcon,
    BaseButton,
    CompanySelect,
  },

  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.populateFilters()
  },

  data() {
    return {
      meterSerial: this.$route.query.meter_serial || '',
      keySerial: this.$route.query.comd_serial || '',
      measuringPoint: this.$route.query.mp_name || '',
      meterType: [],
      comdType: [],
      alert: [],
      keyCompany: [],
      groups: [],
      groupList: [],
      visible: false,
      comdTypes: [
        {label: 'RCM', value: 'rcm'},
        {label: 'RCM-C Prog', value: 'rcmcprog'},
        {label: 'RCMLRWABP', value: 'rcmlrwabp'},
        {label: 'RCMLRWOTAA', value: 'rcmlrwotaa'},
        {label: 'RCMH200', value: 'rcmh200'},
        {label: 'Fuelics ECO', value: 'fuelicsencoder'},
      ],
      meterTypes: [
        {label: 'AFM', value: 'afm'},
        {label: 'GWFcoder', value: 'gwfencoder'},
        {label: 'Intelis', value: 'intelis'},
        {label: 'M7 Prog', value: 'm7prog'},
        {label: 'Sonico', value: 'sonico'},
      ],
      alerts: [
        {label: 'backflow', value: 'backflow'},
        {label: 'battery_low', value: 'battery_low'},
        {label: 'continuous_flow', value: 'continuous_flow'},
        {label: 'broken_pipe', value: 'broken_pipe'},
        {label: 'no_usage', value: 'no_usage'},
        {label: 'system_error', value: 'system_error'},
        {label: 'velocity_error', value: 'velocity_error'},
        {label: 'w_water_error', value: 'w_water_error'},
        {label: 'w_air_error', value: 'w_air_error'},
        {label: 't_water_error', value: 't_water_error'},
        {label: 't_air_error', value: 't_air_error'},
        {label: 'water_level_error', value: 'water_level_error'},
        {label: 'v_sensor_comm_timout', value: 'v_sensor_comm_timout'},
        {label: 'us_water_level', value: 'us_water_level'},
      ],
    }
  },

  watch: {
    $route(n, o) {
      if (_isEmpty(n.query)) {
        this.reset()
      }
    },
    meterSerial(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'meter_serial'})
    },
    keySerial(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'comd_serial'})
    },
    measuringPoint(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'mp_name'})
    },
    keyCompany(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'company'})
    },
    comdType(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'comd_type'})
    },
    meterType(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'meter_type'})
    },
    alert(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'alert'})
    },
    groups(n, o) {
      if (this.mobile) {
        return
      }

      this.$store.dispatch('app/filterProp', {value: n, name: 'groups'})
    },
  },

  methods: {
    async fetchDeviceGroups(refresh = true) {
      if (this.pendingRequest) {
        return
      }
      this.pendingRequest = true
      try {
        await this.$store.dispatch('deviceGroups/getDeviceGroups', refresh)
        return Promise.resolve()
      } catch (e) {
        // TODO: Error notification
        return Promise.reject(e)
      } finally {
        this.groupList = this.$store.getters['deviceGroups/deviceGroups']
      }
    },

    async populateFilters() {
      let query = this.$route.query

      const extractValuesFromQuery = data => {
        let result = []
        if (!data) {
          return result
        }
        if (Array.isArray(data)) {
          result = [...data]
        } else {
          result.push(data)
        }
        return result
      }

      this.alert = extractValuesFromQuery(query.alert)
      this.keyCompany = extractValuesFromQuery(query.company)
      this.comdType = extractValuesFromQuery(query.comd_type)
      this.meterType = extractValuesFromQuery(query.meter_type)
      this.groupList = this.$store.getters['deviceGroups/deviceGroups']

      if (!this.groupList.length) {
        try {
          await this.fetchDeviceGroups()
        } catch (e) {
          console.log(e)
        }
      }
      this.groups = extractValuesFromQuery(query.groups)
    },

    submit() {
      let filters = {
        value: [
          this.meterSerial,
          this.keySerial,
          this.measuringPoint,
          this.keyCompany,
          this.comdType,
          this.meterType,
          this.alert,
          this.groups,
        ],
        name: [
          'meter_serial',
          'comd_serial',
          'mp_name',
          'company',
          'comd_type',
          'meter_type',
          'alert',
          'groups',
        ],
      }
      this.$store.dispatch('app/filterProp', filters)
    },

    reset() {
      this.meterSerial = ''
      this.keySerial = ''
      this.measuringPoint = ''
      this.keyCompany = []
      this.alert = []
      this.groups = []
      this.meterType = []
      this.comdType = []
      this.$router.push({name: 'Devices', query: {}})
    },
  },
}
</script>

<style></style>
